import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomerApplication } from 'services/CustomerService'

export const useCustomerApplicationQuery = (onboardingId: string) => {
  return useQuery({
    queryKey: reactQueryKeys.customerApplication(onboardingId),
    queryFn: () => getCustomerApplication(onboardingId),
    enabled: !!onboardingId,
  })
}
